import { render, staticRenderFns } from "./PainelDocumentosTabelaTodos.vue?vue&type=template&id=011de72a"
import script from "./PainelDocumentosTabelaTodos.vue?vue&type=script&lang=js"
export * from "./PainelDocumentosTabelaTodos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports